// Angular
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';
// Layout
import { LayoutConfigService } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';

@Component({
  selector: 'kt-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['brand.component.scss']
})
export class BrandComponent implements OnInit {
  headerLogo: string;
  headerStickyLogo: string;
  menuHeaderDisplay: boolean;

  constructor(
    private layoutConfigService: LayoutConfigService,
    public htmlClassService: HtmlClassService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.initLogos(LanguageType[this.translateService.getBrowserLang()]);
    this.initLanguageChanges();
  }

  private initLogos(languageType: LanguageType): void {
    this.headerLogo = this.layoutConfigService.getLogo(languageType);
    this.headerStickyLogo = this.layoutConfigService.getStickyLogo(languageType);
  }

  private initLanguageChanges(): void {
    this.translateService.onLangChange
      .subscribe((lce: LangChangeEvent) => {
        this.initLogos(LanguageType[lce.lang]);
        this.cdr.detectChanges();
      });
  }
}
